/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

/* eslint-disable no-console */
import $ from 'jquery';
import DataState from '../enums/DataState';
import MetadataState from '../enums/MetadataState';

// dataGrid group
import CrosstabVisualizationDescriptor from '../components/visualizations/crosstab/CrosstabVisualization';
import { IState } from './types/StateTypes';
import { getTableUIComponent } from '../reducers/metadataReducerHelpers/getTableUIComponent';
import { getCrosstabUIComponent } from '../reducers/metadataReducerHelpers/getCrosstabUIComponent';
import { getCommonChartUIComponent } from '../reducers/metadataReducerHelpers/getCommonChartUIComponent';
import { IMetadata } from './types/MetadataTypes';
import { buildVisualizationTypesRegistry, initializeVisualizationProperties } from './visualizationTypesRegistry';
import { initialStateOfVisualizationChooser } from './initialState/visualizationChooser';
import datasetTypes from '../enums/datasetTypes';

export default function initialState():IState {
    return initializeVisualizationProperties({
        autoresize: true,
        server: '',
        canvas: null,
        adHocViewHeight: 400,
        adHocViewWidth: 400,
        resourceURI: '',
        metadataState: MetadataState.LOADED,
        metadataError: null,
        dataState: DataState.LOADED,
        dataError: null,
        dataLimit: -1,
        deferredAction: $.Deferred(),
        drillDownAllowed: true,

        // the event callback are functions which can be used to subscribe to certain events
        eventCallbacks: {},

        isInDesignerMode: false,

        titleOptions: {
            // next fields can be set from API and from resource's data
            // and here we define their default values
            title: '',
            showTitleFlagFromAPI: null,
            showTitleFlagFromMetadata: null,
            domNodeHeight: 0,

            // and the next fields represent internal component's state
            showTitle: true,
            inEditingMode: false
        },

        metadata: {
            uiComponents: [
                getTableUIComponent(({ component: null } as unknown) as IMetadata, { columns: [], rows: [] }),
                getCrosstabUIComponent(({ component: null } as unknown) as IMetadata, { columns: [], rows: [] }),
                getCommonChartUIComponent(({ component: null } as unknown) as IMetadata, { columns: [], rows: [] }),
            ]
        },
        visualizationDescriptor: CrosstabVisualizationDescriptor,
        visualizationTypesRegistry: buildVisualizationTypesRegistry(),

        filterExpression: null,
        filterParameters: [],

        orderInformation: {
            members: [],
            levels: [],
            topN: [],
            bottomN: []
        },

        levelsLayout: {
            rows: [],
            columns: []
        },

        data: {
            [datasetTypes.SAMPLE]: {/* Dataset specific fields */},
            [datasetTypes.MULTI_AXIS]: {
                summary: {
                    rows: {
                        complete: true,
                        empty: true,
                        items: [],
                        expansions: []
                    },
                    columns: {
                        complete: true,
                        empty: true,
                        items: [],
                        expansions: []
                    },
                    aggregations: []
                },
                data: {
                    rows: {
                        index: -1,
                        label: '',
                        expanded: true,
                        children: []
                    },
                    columns: {
                        index: -1,
                        label: '',
                        expanded: true,
                        children: []
                    },
                    aggregations: [[]]
                }
            },
            [datasetTypes.MULTI_LEVEL]: {
                summary: {
                    complete: true,
                    empty: true,
                    groups: [],
                    details: [],
                    aggregations: []
                },
                data: {
                    index: -1,
                    nodeType: 'root',
                    children: [],
                    values: []

                }
            }
        },
        visualization: {},
        visualizationChooser: {
            ...initialStateOfVisualizationChooser
        },
        refreshData: false
    });
}
